// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"b1360c5d","453":"61f7da06"}[chunkId] + ".chunk.js";
};